import script from "./CadernoView.vue?vue&type=script&setup=true&lang=js"
export * from "./CadernoView.vue?vue&type=script&setup=true&lang=js"

import "./CadernoView.vue?vue&type=style&index=0&id=1ca42056&lang=css"

const __exports__ = script;

export default __exports__